/**
 * Semantic Opacity Tokens — CSS variable references.
 */

export const opacity = {
  subtle: "var(--op-subtle)",
  disabled: "var(--op-disabled)",
  muted: "var(--op-muted)",
  hover: "var(--op-hover)",
  loading: "var(--op-loading)",
} as const;
